import Link from 'next/link'

import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import { getCategoryTitle } from 'app/ProfileRevampPage/utils/perangkatAjar'
import { useProfile } from 'app/ProfileRevampPage/hooks/useProfile'
import { useSETrackEventToolkits } from 'app/ProfileRevampPage/hooks/useSETrackEventToolkits'

interface PerangkatAjarListItemProps
  extends React.HTMLAttributes<HTMLAnchorElement> {
  type?: string
  subtitle?: string
  href?: string
}

function PerangkatAjarListItem({
  type,
  subtitle,
  href = '#',
  ...props
}: PerangkatAjarListItemProps) {
  const { isNarasumber, perangkatAjarCount, profileData } = useProfile()
  const { SETrackClickToolkitCategory } = useSETrackEventToolkits()

  const onClickItem = () => {
    const currentType = (profileData?.toolkits ?? []).find(
      ({ type: toolkitType }) => type === toolkitType
    )
    SETrackClickToolkitCategory({
      isNarasumber,
      toolkitType: type,
      numToolkit: perangkatAjarCount,
      numTypeToolkit: currentType?.count ?? 0,
    })
  }

  return (
    <Link href={href} passHref>
      <a
        {...props}
        className="flex items-center justify-between gap-4 py-4 cursor-pointer"
        onClick={onClickItem}
      >
        <div>
          <Text variant="action">{getCategoryTitle(type)}</Text>
          <Text variant="body" color="subdued">
            {subtitle}
          </Text>
        </div>
        <Icon>chevron_right</Icon>
      </a>
    </Link>
  )
}

export default PerangkatAjarListItem
